import ContentContainer from 'components/content-container/ContentContainer';
import Link from 'components/link/Link';
import RichText from 'components/rich-text/RichText';
import SocialMediaLinkList from 'components/social-media-link-list/SocialMediaLinkList';
import AccordionContainer from 'components/accordion-container/AccordionContainer';

import { IFooter } from 'source/NFR.types';

const Footer: React.FC<IFooter> = ({ contactInfo, newsLetter, linkLists, socialMedia, logo, about, trademark }) => (
  <footer className="footer">
    <ContentContainer className="footer__content">
      <div className="footer__top">
        <div className="footer__top-left">
          {logo && (
            <a href={logo.url} aria-label={logo.text} className="footer__logo">
              <img alt="Logo" loading="lazy" src={logo.src} />
            </a>
          )}
          {about && <p className="footer__about">{about}</p>}
          {newsLetter && (
            <Link
              className="footer__newsletter-link"
              theme={['primary', 'light', 'large']}
              useButtonStyles
              {...newsLetter}
            />
          )}
        </div>
        <div className="footer__top-right-mobile">
          {linkLists?.map(({ title, links, id, accordion }) => (
            <div className="footer__link-list" key={id}>
              <AccordionContainer buttonText={title} accordion={accordion}>
                {links && !!links.length && (
                  <ul>
                    {links?.map(link => (
                      <li key={link.text}>
                        <Link theme="white" {...link} />
                      </li>
                    ))}
                  </ul>
                )}
              </AccordionContainer>
            </div>
          ))}
        </div>
        <div className="footer__top-right-desktop">
          {linkLists?.map(({ title, links, id }) => (
            <div className="footer__link-list" key={id}>
              {title && <h2>{title}</h2>}
              {links && !!links.length && (
                <ul>
                  {links?.map(link => (
                    <li key={link.text}>
                      <Link theme="white" {...link} />
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
      {contactInfo && (
        <div className="footer__contact-info">
          <RichText
            {...contactInfo}
            additionalComponentProps={{
              HtmlString: { theme: 'white' }
            }}
          />
        </div>
      )}
      <div className="footer__bottom">
        <div>{trademark && trademark}</div>
        <SocialMediaLinkList className="footer__bottom-some-links" theme="white" {...socialMedia} />
      </div>
    </ContentContainer>
  </footer>
);

Footer.displayName = 'Footer';

export default Footer;
